<template>
  <div class="Category flex-column">
    <div class="page-title flex-fixed">품목구분관리</div>
    <div class="flex-fixed">
      <span class="text-warning">수정/삭제 하려면 더블 클릭하세요.</span>
    </div>
    <div class="detail-container flex-fixed flex">      
      <div class="flex-column flex-fixed column">
        <div class="list-title flex-fixed">대분류</div>
        <div class="flex-auto">
          <select ref="select1" class="w-full" size="15"
            @change="handleChangeCategory1"
            @dblclick="handleModifyCategory(1)"
          >
            <option 
              v-for="item in category1Items" 
              v-bind:key="item.id" 
              v-bind:value="item.id"
              v-bind:label="item.name"/>
          </select>
        </div>
      </div>
      <div class="flex-column flex-fixed column">
        <div class="list-title flex-fixed">중분류</div>
        <div class="flex-auto">
          <select class="w-full" size="15"
            @change="handleChangeCategory2"
            @dblclick="handleModifyCategory(2)"
          >
            <option 
              v-for="item in category2Items" 
              v-bind:key="item.id" 
              v-bind:value="item.id"
              v-bind:label="item.name"/>
          </select>
        </div>
      </div>
      <div class="flex-column flex-fixed column">
        <div class="list-title flex-fixed">소분류</div>
        <div class="flex-auto">
          <select class="w-full" size="15"
            @change="handleChangeCategory3"
            @dblclick="handleModifyCategory(3)"
          >
            <option 
              v-for="item in category3Items" 
              v-bind:key="item.id" 
              v-bind:value="item.id"
              v-bind:label="item.name"/>
          </select>
        </div>
      </div>
    </div>
    <div class="flex-fixed">
      <el-button
        type="primary"
        :disabled="!has_grant_write"
        @click="handleClickAdd"
      >분류 추가</el-button>
    </div>
    <el-dialog
      custom-class="mini-form-dialog"
      top="0"
      title="품목 분류"
      destroyOnClose
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      @opened="handleOpened"
    >
      <ProductTypeForm ref="form" :data="form_data" :has_grant_write="has_grant_write" @completed="handleCompleted" />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { form_container } from "@/common/mixins/form_container";
import { authority_level } from "@/common/mixins/authority_level";
import ProductTypeForm from "./ProductTypeForm";

export default {
  name: "Category",
  mixins: [form_container, authority_level],
  components: { ProductTypeForm },
  data() {
    return {
      selectedCategory1Index: -1,
      category1: 0,
      category2: 0,
      category3: 0,
      dialogVisible: false,
      form_data: undefined,
    }    
  },  
  computed: {
    ...mapGetters(["table_product_type"]),
    category1Items: function() {  
      let categroy1 = this.table_product_type.filter(c => !c.parent_id);
      categroy1.sort(this.util.sortDescByName);
      return categroy1;
    },
    category2Items: function() {      
      if (!this.category1) { return []; }      
      let item = this.table_product_type.filter(c => c.parent_id === this.category1);
      item.sort(this.util.sortDescByName);
      return item;
    },
    category3Items: function() {    
      if (!this.category2) { return []; }
      let item = this.table_product_type.filter(c => c.parent_id === this.category2);
      item.sort(this.util.sortDescByName);
      return item;
    },    
    has_grant_write() {      
      return this.isWriteLevel('product_type');
    },
  },
  mounted() {
    if (this.category1Items.length < 1) { return; }
    this.category1 = this.category1Items[0].id;
  },
  methods: {
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleTreeChange(value) {
      this.category_id = value.id;
    },
    handleChangeCategory1(event) {
      this.category1 = Number.parseInt(event.target.value);
      this.category2 = 0;
      this.category3 = 0;
    },
    handleChangeCategory2(event) {
      this.category2 = Number.parseInt(event.target.value);
      this.category3 = 0;
    },
    handleChangeCategory3(event) {
      this.category3 = Number.parseInt(event.target.value);
    },
    handleModifyCategory(index) {
      let item = undefined;
      switch(index) {
        case 2:
          item = this.category2Items.find(i => i.id === this.category2);
          break;
        case 3:
          item = this.category3Items.find(i => i.id === this.category3);
          break;
        default:
          item = this.category1Items.find(i => i.id === this.category1);
          break;
      }
      if (!item) { return; }
      this.dialogVisible = true;
      this.form_data = Object.assign({}, item);
    },
    handleClickAdd() {
      this.form_data = undefined;
      this.dialogVisible = true;
    },
    handleCompleted(message) {
      this.dialogVisible = false;
      if (!message) { return; }
      this.$notify(message);
    },
  },
}
</script>

<style lang="scss" scoped>
.column { 
  width: 32%;
  &:not(:last-child) {
    margin-right: 20px;
  }
}
.detail-container {
  height: 420px;
}
.form-dialog {
  width: 500px;
}
select {
  height: 380px;;
}
</style>
